module.exports = __webpack_public_path__ + "6e70b76c5535b8f1761679c8649c5940.MP3";